import { Form } from "components/Form/components/Form/Form";
import { ImageUpload } from "components/Form/components/ImageUpload/ImageUpload";
import { getDefaultProjectId } from "containers/Projects/Projects.selectors";
import { useMemo, useRef } from "react";
import { Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { useSelector } from "react-redux";
import "./ResourcePageHeaderIconForm.scss";

interface ResourcePageHeaderIconFormProps {
    handleSubmit: () => void;
    recordId?: string;
    isReadOnly: boolean;
    /** Enable the curated built-in-icon picker alongside upload (opt-in per resource). */
    enableCuratedPicker?: boolean;
}

export const ResourcePageHeaderIconForm = ({
    handleSubmit,
    recordId,
    isReadOnly,
    enableCuratedPicker = false,
}: ResourcePageHeaderIconFormProps) => {
    const popOverRef = useRef<HTMLDivElement>(null);

    const defaultProjectId = useSelector(getDefaultProjectId);

    const isDisabled = useMemo(() => recordId === defaultProjectId, [defaultProjectId, recordId]);

    return (
        <div className="resource-page-header-form-icon" ref={popOverRef}>
            <Form.Row verticalCenter>
                <Field
                    name="icon"
                    id="icon"
                    fieldAttr={{
                        autoFocus: true,
                        disabled: isDisabled || isReadOnly,
                    }}
                    fieldProps={{ enableCuratedPicker }}
                    component={ImageUpload}
                />
                <OnChange name="icon">{handleSubmit}</OnChange>
            </Form.Row>
        </div>
    );
};
